import { lazy, type ComponentType } from "react";

const KEY = "chunk-reload-at";

/**
 * React.lazy with recovery for stale chunks (common after a new deploy):
 * retries the import once, then forces a single full reload.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      try {
        return await factory();
      } catch {
        const last = Number(sessionStorage.getItem(KEY) || 0);
        if (Date.now() - last > 10000) {
          sessionStorage.setItem(KEY, String(Date.now()));
          window.location.reload();
          return new Promise<never>(() => {});
        }
        throw err;
      }
    }
  });
}
